import { GGOBaseComponent, Translate } from '@galigeo-store/ui-lib';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './rights.admin.component.js';
import './logs.admin.component.js';

@customElement('general-admin-page')
export class GeneralAdminPage extends GGOBaseComponent {



  render() {

    const menuItems = [
      { label: Translate.get('admin_rights'), icon: 'utility:block_visitor', selected: true, getContent: () => html`<rights-admin-page></rights-admin-page>` },
      { label: Translate.get('admin_logs'), icon: 'utility:display_text', getContent: () => html`<log-admin-page></log-admin-page>` },

    ];
    return html`
      <ggo-config-menu .menuItems=${menuItems} .selectedItem=${menuItems[0]}>
      </ggo-config-menu>
      `
  }
}